export const eventsConstants = {
    CREATE_ACCOUNT: 'create_account',
    VERIFY_EMAIL: 'verify_email',
    PERSONAL_INFO: 'personal_information',
    MILITARY_SERVICE: 'military_service',
    PRIVACY_WAIVER: 'privacy_waiver',
    RED_SHIRT: 'red_shirt',
    EVENTS: 'events',
    FEED: 'feed',
    MY_ACTIVITIES: 'my_activities',
    UPCOMING_EVENTS: 'upcoming_events',
    PAST_EVENTS: 'past_events',
    MY_PROFILE: 'my_profile',
    PHOTO_UPLOAD: 'photo_upload',
    FORGOT_PASSWORD: 'forgot_password',
    LOGIN: 'login',
    LOGOUT: 'logout',
    SEARCH: 'search',
    DISTANCE_FILTER: 'distance_filter',
    DATE_FILTER: 'date_filter',
    ACTIVITY_FILTER: 'activity_filter',
    CHAPTER_TOGGLE: 'chapter_toggle',
    HOST_FILTER: 'host_toggle',
    SORT_FILTER: 'sort_filter',
    VIRTUAL_TOGGLE: 'virutal_toggle',
    EVENT_SELECTION: 'event_selection',
    INTERESTED: 'interested',
    GOING: 'going',
    CHECK_IN: 'check_in',
    CALENDAR: 'calendar',
    MAP: 'map',
    ADDRESS: 'address',
    SHARE: 'share',
    ATTENDEES: 'attendees',
    INTERESTED_NOTIFICATION: 'interested_notification',
    GOING_NOTIFICATION: 'going_notification',
    CHECK_IN_NOTIFICATION: 'check_in_notification',
    MY_NOTIFICATIONS: 'my_notifications',

};

export const labelConstants = {
    CREATE_ACCOUNT: 'Create Account',
    VERIFY_EMAIL: 'Verify Email',
    PERSONAL_INFO: 'Personal Information',
    MILITARY_SERVICE: 'Military Service',
    PRIVACY_WAIVER: 'Privacy Waiver',
    RED_SHIRT: 'Red Shirt',
    EVENTS: 'Events',
    MY_ACTIVITIES: 'My Activities',
    UPCOMING_EVENTS: 'Upcoming  Events',
    PAST_EVENTS: 'Past Events',
    MY_PROFILE: 'My Profile',
    PHOTO_UPLOAD: 'Photo Upload',
    FORGOT_PASSWORD: 'Forgot Password',
    LOGIN: 'Login',
    LOGOUT: 'Logout',
    SEARCH: 'Search',
    DISTANCE_FILTER: 'Distance Filter',
    DATE_FILTER: 'DATE Filter',
    ACTIVITY_FILTER: 'Activity Filter',
    CHAPTER_TOGGLE: 'Chapter Toggle',
    HOST_FILTER: 'Host Filter',
    SORT_FILTER: 'Sort Filter',
    VIRTUAL_TOGGLE: 'Virutal Toggle',
    EVENT_SELECTION: 'Event Selection',
    INTERESTED: 'Interested',
    GOING: 'Going',
    CHECK_IN: 'Check-In',
    CALENDAR: 'Calendar',
    MAP: 'Map',
    ADDRESS: 'Address',
    SAHRE: 'Share',
    ATTENDEES: 'Attendees',
    INTERESTED_NOTIFICATION: 'Interested Notification',
    GOING_NOTIFICATION: 'Going Notification',
    CHECK_IN_NOTIFICATION: 'Check-In Notification',
    MY_NOTIFICATIONS: 'My Notifications',
    START_CREATE_EVENT: 'Event Button',
    CHOOSE_MEMBER_EVENT: 'Choose Member Event',
    CHOOSE_CHAPTER_EVENT: 'Choose Chapter Event',
    CREATE_EVENT: 'Create Event',
    CANCEL_EVENT: 'Cancel Event',
    UPDATE_EVENT: 'Update Event',
    EVENT_STATUS: 'Event Status',
    ACCESS_NOTIFICATION: 'Access Notification',
    NOTIFICATION_LIKE: 'Notification Like',
    FEED_POST: 'Feed Post',
    FEED_LIKE: 'Feed Like',
    PEOPLE_SEARCH: 'People Search',
    FOLLOW: 'Follow',
    UNFOLLOW: 'Unfollow',
};

export const categoryConstants = {
    REGISTRATION: 'Registration',
    NAVIGATION: 'Navigation',
    PROFILE_MANAGEMENT: 'Profile Management',
    EVENT_LIST: 'Events List',
    EVENT_DETAIL: 'Event Detail',
    EVENT_ATTENDEES: 'Event Attendees',
    NOTIFICATION: 'Notification',

};

export const parameterConstants = {
    EVENT_STATUS: 'Event Status'
};
